import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { Link } from 'react-router-dom';

const Login = ({ setlogin, show }) => {
    const handleClose = () => setlogin(false);
    
    const styles = {
        mainModal: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            padding: '20px 25px',
            borderRadius: '10px 10px 0 0',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
        },
        modalIcon: {
            fontSize: '24px',
            color: 'white',
            backgroundColor: 'rgba(255,255,255,0.2)',
            padding: '12px',
            borderRadius: '50%',
            width: '48px',
            height: '48px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        },
        modalTitle: {
            fontSize: '18px',
            fontWeight: '600',
            color: 'white',
            margin: 0,
            letterSpacing: '0.5px'
        },
        closeBtn: {
            color: 'white',
            fontSize: '20px',
            cursor: 'pointer',
            padding: '8px',
            borderRadius: '50%',
            transition: 'background-color 0.3s ease',
            backgroundColor: 'transparent',
            border: 'none'
        },
        mainDiv: {
            padding: '30px',
            backgroundColor: '#ffffff'
        },
        loginSection: {
            paddingRight: '30px',
            borderRight: '1px solid #e9ecef'
        },
        inputGroup: {
            marginBottom: '20px',
            position: 'relative'
        },
        inputGroupText: {
            backgroundColor: '#f8f9fa',
            border: '1px solid #dee2e6',
            borderRight: 'none',
            color: '#6c757d'
        },
        formControl: {
            border: '1px solid #dee2e6',
            borderLeft: 'none',
            padding: '12px 15px',
            fontSize: '14px',
            transition: 'border-color 0.3s ease, box-shadow 0.3s ease'
        },
        socialText: {
            color: '#6c757d',
            fontSize: '14px',
            marginBottom: '15px',
            textAlign: 'center'
        },
        socialIcons: {
            display: 'flex',
            gap: '10px',
            marginBottom: '20px',
            justifyContent: 'center'
        },
        socialBtn: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            width: '45px',
            height: '45px',
            borderRadius: '8px',
            color: 'white',
            textDecoration: 'none',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            fontSize: '18px'
        },
        forgotPassword: {
            color: '#6c757d',
            fontSize: '14px',
            textDecoration: 'none',
            textAlign: 'center',
            display: 'block',
            marginBottom: '20px',
            transition: 'color 0.3s ease'
        },
        loginBtn: {
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            border: 'none',
            color: 'white',
            padding: '12px 30px',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'transform 0.3s ease, box-shadow 0.3s ease',
            width: '100%',
            textDecoration: 'none',
            display: 'inline-block',
            textAlign: 'center'
        },
        createSection: {
            paddingLeft: '30px',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        newHereTitle: {
            color: '#2c3e50',
            fontSize: '20px',
            fontWeight: '600',
            marginBottom: '10px'
        },
        newHereText: {
            color: '#6c757d',
            fontSize: '14px',
            marginBottom: '20px'
        },
        benefitsList: {
            listStyle: 'none',
            padding: 0,
            marginBottom: '25px'
        },
        benefitItem: {
            color: '#6c757d',
            fontSize: '14px',
            marginBottom: '8px',
            paddingLeft: '20px',
            position: 'relative'
        },
        createBtn: {
            background: 'transparent',
            border: '2px solid #667eea',
            color: '#667eea',
            padding: '12px 30px',
            borderRadius: '8px',
            fontSize: '14px',
            fontWeight: '600',
            transition: 'all 0.3s ease',
            textDecoration: 'none',
            display: 'inline-block',
            textAlign: 'center'
        },
        modalContent: {
            border: 'none',
            borderRadius: '10px',
            overflow: 'hidden',
            boxShadow: '0 10px 30px rgba(0,0,0,0.2)'
        }
    };

    return (
        <>
            <style>
                {`
                .custom-modal .modal-content {
                    border: none;
                    border-radius: 10px;
                    overflow: hidden;
                    box-shadow: 0 10px 30px rgba(0,0,0,0.2);
                }
                
                .form-control:focus {
                    border-color: #667eea;
                    box-shadow: 0 0 0 0.2rem rgba(102, 126, 234, 0.25);
                }
                
                .social-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 5px 15px rgba(0,0,0,0.2);
                }
                
                .forgot-password:hover {
                    color: #667eea;
                }
                
                .login-btn:hover {
                    transform: translateY(-2px);
                    box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
                }
                
                .create-btn:hover {
                    background-color: #667eea;
                    color: white;
                    transform: translateY(-2px);
                    box-shadow: 0 5px 15px rgba(102, 126, 234, 0.4);
                }
                
                .close-btn:hover {
                    background-color: rgba(255,255,255,0.2);
                }
                
                .benefit-item::before {
                    content: "✓";
                    position: absolute;
                    left: 0;
                    color: #28a745;
                    font-weight: bold;
                }
                
                @media (max-width: 768px) {
                    .login-section {
                        border-right: none;
                        border-bottom: 1px solid #e9ecef;
                        padding-right: 15px;
                        padding-bottom: 30px;
                        margin-bottom: 30px;
                    }
                    
                    .create-section {
                        padding-left: 15px;
                    }
                }
                `}
            </style>
            
            <Modal show={show} onHide={handleClose} className="custom-modal">
                <div style={styles.modalContent}>
                    <div style={styles.mainModal}>
                        <div style={styles.modalIcon}>
                            <i className="fa fa-user" aria-hidden="true"></i>
                        </div>
                        <h5 style={styles.modalTitle}>SIGN IN OR REGISTER</h5>
                        <button 
                            onClick={handleClose} 
                            style={styles.closeBtn}
                            className="close-btn"
                        >
                            <i className='fa fa-times'></i>
                        </button>
                    </div>
                    
                    <div style={styles.mainDiv}>
                        <div className="row">
                            <div className="col-md-6">
                                <div style={styles.loginSection} className="login-section">
                                    <div style={styles.inputGroup}>
                                        <div className="input-group">
                                            <span className="input-group-text fa fa-user" style={styles.inputGroupText}></span>
                                            <input 
                                                type="email" 
                                                className="form-control" 
                                                placeholder="Email Address" 
                                                style={styles.formControl}
                                            />
                                        </div>
                                    </div>
                                    
                                    <div style={styles.inputGroup}>
                                        <div className="input-group">
                                            <span className="input-group-text fa fa-lock" style={styles.inputGroupText}></span>
                                            <input 
                                                type="password" 
                                                className="form-control" 
                                                placeholder="Password" 
                                                style={styles.formControl}
                                            />
                                        </div>
                                    </div>
                                    
                                    <p style={styles.socialText}>Or login with your social account</p>
                                    
                                    <div style={styles.socialIcons}>
                                        <a href="#" style={{...styles.socialBtn, backgroundColor: '#dd4b39'}} className="social-btn">
                                            <i className="fa fa-google"></i>
                                        </a>
                                        <a href="#" style={{...styles.socialBtn, backgroundColor: '#3b5998'}} className="social-btn">
                                            <i className="fa fa-facebook"></i>
                                        </a>
                                        <a href="#" style={{...styles.socialBtn, backgroundColor: '#55acee'}} className="social-btn">
                                            <i className="fa fa-twitter"></i>
                                        </a>
                                        <a href="#" style={{...styles.socialBtn, backgroundColor: '#0e76a8'}} className="social-btn">
                                            <i className="fa fa-linkedin"></i>
                                        </a>
                                    </div>
                                    
                                    <a href="#" style={styles.forgotPassword} className="forgot-password">
                                        Forgot your password?
                                    </a>
                                    
                                    <Link 
                                        to='/dashboard' 
                                        onClick={handleClose} 
                                        style={styles.loginBtn}
                                        className="login-btn"
                                    >
                                        SIGN IN
                                    </Link>
                                </div>
                            </div>
                            
                            <div className="col-md-6">
                                <div style={styles.createSection} className="create-section">
                                    <h5 style={styles.newHereTitle}>NEW HERE?</h5>
                                    <p style={styles.newHereText}>Registration is free and easy!</p>
                                    
                                    <ul style={styles.benefitsList}>
                                        <li style={styles.benefitItem} className="benefit-item">Faster checkout process</li>
                                        <li style={styles.benefitItem} className="benefit-item">Save multiple shipping addresses</li>
                                        <li style={styles.benefitItem} className="benefit-item">View and track your orders</li>
                                        <li style={styles.benefitItem} className="benefit-item">Exclusive member discounts</li>
                                    </ul>
                                    
                                    <Link 
                                        to="/register"  
                                        onClick={handleClose} 
                                        style={styles.createBtn}
                                        className="create-btn"
                                    >
                                        CREATE ACCOUNT
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </>
    );
};

export default Login;